import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UserprofileComponent} from './userprofile.component';
import {FlexLayoutModule} from '@angular/flex-layout';
import {AgGridModule} from 'ag-grid-angular';
import {
  MatButtonModule,
  MatCardModule,
  MatDividerModule, MatExpansionModule,
  MatFormFieldModule,
  MatInputModule,
  MatSelectModule,
  MatTabsModule
} from '@angular/material';
import {MatIconModule} from '@angular/material/icon';
import {ReactiveFormsModule} from '@angular/forms';



@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatCardModule,
    MatIconModule,
    AgGridModule.withComponents([]),
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatTabsModule,
    MatDividerModule,
    MatExpansionModule
  ],
  providers: [],
  exports: [MatCardModule, MatIconModule],
  declarations: [UserprofileComponent]
})
export class UserprofileModule {
}
